import {Utils} from '../underscore-extensions';
import {AuthenticationSvc} from '../services/AuthenticationSvc';

class SignUpBlock implements ng.IComponentController {
    email: string;
    isBg: boolean;
    sbTitle: string;

    constructor(private $state: ng.ui.IStateService,
                private AuthenticationSvc: AuthenticationSvc) {
        const defautlTitle = options.handHeld ? 'sign-up-block.mobile.title' : 'sign-up-block.title'
        this.sbTitle = this.sbTitle || defautlTitle;
    }

    isEmailInvalid(form: ng.IFormController) {
        return form && form.$invalid && (form.$submitted || form.$dirty);
    }

    openLoginModal() {
        this.AuthenticationSvc.toggleLoginModal();
    }

    openSignUp() {
        const state = Utils.getProduct().toLowerCase();
        this.$state.go(`${state}-signup`, {email: this.email, sendRequest: true})
    }
}

angular.module('animatronApp.signUpBlock', []).component('signUpBlock', {
    bindings: {
        isBg: '<',
        sbTitle: '<'
    },
    controller: SignUpBlock,
    templateUrl: require('sign-up-block.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/signUpBlock.ts